import { computeRotationAngleSync } from '@/lib/boundaries/bounding-box-boundary'
import { resolveSnappedRotationDegrees } from '@/lib/guides/smart-guides'

/** The pivot/start-angle fields shared by both rotate drags (photo and shape). */
interface RotationDragPivot {
  centerClientX: number
  centerClientY: number
  startAngleRad: number
}

/**
 * Shared by the live move and pointer-up handlers so both resolve the exact same angle for
 * the same pointer position — reuses `computeRotationAngleSync`, the same synchronous
 * atan2-based formula the normal (multi-purpose) selection rotate handle uses, then applies
 * the same Shift-snap-to-15°/smart-guide snapping via `resolveSnappedRotationDegrees` (smart
 * guides disabled here — this overlay doesn't have visibility into other canvas objects).
 *
 * Serves both the photo rotate drag and the SHAPE rotate drag — they differ only in which
 * rotation they started from (`initialRotation`: the photo fill's or the shape's own).
 */
export function resolveDragRotationDegrees(
  drag: RotationDragPivot,
  initialRotation: number,
  clientX: number,
  clientY: number,
  shiftKey: boolean
): number {
  const result = computeRotationAngleSync({
    centerX: drag.centerClientX,
    centerY: drag.centerClientY,
    mouseX: clientX,
    mouseY: clientY,
    startAngle: drag.startAngleRad,
    initialRotation,
  })

  return resolveSnappedRotationDegrees(result.degrees, {
    shiftKey,
    smartGuidesEnabled: false,
  }).degrees
}
